import React from 'react';

import {SequenceAnalysis} from 'constants/SequenceConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface DuplicateModalProps {
  analyses: Array<SequenceAnalysis>;
  name: string;
}

function DuplicateModal({analyses, name}: DuplicateModalProps): JSX.Element {
  return (
    <form
      className="duplicate-modal-form"
      {...getTestProps({component: 'DuplicateSequenceModal', element: 'root'})}
    >
      <div className="form-group">
        <input
          type="text"
          placeholder="New sequence name"
          className="name-input"
          defaultValue={name}
          {...getTestProps({component: 'DuplicateSequenceModal', element: 'nameInput'})}
        />
      </div>
      <div className="form-group">
        <div className="folder-selector-container" />
      </div>
      <div className="row">
        {analyses.length > 0 && (
          <div className="col col-md-6">
            <h4>
              <input type="checkbox" className="select-all-analyses select-all" defaultChecked={true} />
              Copy Analyses:
            </h4>
            <ul className="copy-list">
              {analyses.map((analysis) => (
                <li key={analysis.id}>
                  <label>
                    <input
                      type="checkbox"
                      className="copied-analysis"
                      defaultChecked={true}
                      value={analysis.id}
                    />
                    {analysis.name}
                  </label>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </form>
  );
}

export default makeDeprecatedJadeStyleTemplate<DuplicateModalProps>(DuplicateModal);
